<template>
  <div class="app-main-inner">
    <div class="app-main-middle">
       <div class="paymentInfo-box" v-if="step===2">
          <h1 class="paymentInfo-title">Bank Transfer</h1>
          <h2>If you need a bank transfer, you must fill in the following information.<br>If you do not need,this information can be skipped</h2>
          <el-form ref="bankForm" :model="bankForm" autoComplete="off" :rules="bankFormRules">
            <div class="form-group">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels">Account type</label>
                    <el-form-item prop="accountType">
                      <el-input v-model="bankForm.accountType"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels">Bank name</label>
                    <el-form-item prop="bankName">
                      <el-input v-model="bankForm.bankName"></el-input>
                    </el-form-item>                
                  </div>
                </el-col>
              </el-row>
            </div> 
            <div class="form-group">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels">Routing number</label>
                    <el-form-item prop="routingNumber">
                      <el-input v-model="bankForm.routingNumber"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels">Confirm routing number</label>
                    <el-form-item prop="confirmRoutingNumber">
                      <el-input v-model="bankForm.confirmRoutingNumber"></el-input>
                    </el-form-item>                
                  </div>
                </el-col>
              </el-row>
            </div>     
            <div class="form-group">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels">Account number</label>
                    <el-form-item prop="accountNumber">
                      <el-input v-model="bankForm.accountNumber"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels">Confirm account number</label>
                    <el-form-item prop="confirmAccountNumber">
                      <el-input v-model="bankForm.confirmAccountNumber"></el-input>
                    </el-form-item>                
                  </div>
                </el-col>
              </el-row>
            </div>  
            <div class="form-group">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels">Deposit distribution</label>
                    <el-form-item prop="depositDistribution">
                      <el-input v-model="bankForm.depositDistribution"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels">Nickname</label>
                    <el-form-item prop="nickname">
                      <el-input v-model="bankForm.nickname"></el-input>
                    </el-form-item>                
                  </div>
                </el-col>
              </el-row>
            </div>     
            <div class="form-group text-align-center">
              <el-button class="btn" :loading="btnLoading" @click="saveBankInfo">Finish</el-button>
            </div>     
          </el-form>
       </div>
       <div class="paymentInfo-box" v-else>
          <h1>Check Information</h1>
          <h2>If you want to withdraw, you must fill in the following information</h2>
          <div class="paymentInfo-title"><span>Contractor Info</span><div class="line"></div></div>
          <el-form ref="paymentInfoParam" :model="paymentInfoParam" autoComplete="off" :rules="formRules">
            <div class="form-group">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels"><span>*</span>First name</label>
                    <el-form-item prop="firstName">
                      <el-input v-model="paymentInfoParam.firstName"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels">Middle initial</label>
                    <el-form-item prop="middleInitial">
                      <el-input v-model="paymentInfoParam.middleInitial"></el-input>
                    </el-form-item>                
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="form-group">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels"><span>*</span>Last name</label>
                    <el-form-item prop="lastName">
                      <el-input v-model="paymentInfoParam.lastName"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels"><span>*</span>Social security no</label>
                    <el-form-item prop="socialSecurityNo">
                      <el-input v-model="paymentInfoParam.socialSecurityNo"></el-input>
                    </el-form-item>                
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="form-group">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels">Company name</label>
                    <el-form-item prop="companyName">
                      <el-input v-model="paymentInfoParam.companyName"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels">TIN</label>
                    <el-form-item prop="tin">
                      <el-input v-model="paymentInfoParam.tin"></el-input>
                    </el-form-item>                
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="form-group">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels">Address line 1</label>
                    <el-form-item prop="addressLine1">
                      <el-input v-model="paymentInfoParam.addressLine1"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels">Address line 2</label>
                    <el-form-item prop="addressLine2">
                      <el-input v-model="paymentInfoParam.addressLine2"></el-input>
                    </el-form-item>                
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="form-group">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels">City</label>
                    <el-form-item prop="city">
                      <el-input v-model="paymentInfoParam.city"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels"><span>*</span>State/Province</label>
                    <div class="select-box">
                      <el-form-item prop="state">
                        <el-select  v-model="paymentInfoParam.state" placeholder="Select a value">
                          <el-option
                            v-for="item in provinceList"
                            :key="item.id"
                            :label="item"
                            :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div>            
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="form-group">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels">Zip code</label>
                    <el-form-item prop="zipCode">
                      <el-input v-model="paymentInfoParam.zipCode"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels"><span>*</span>Phone</label>
                    <el-form-item prop="phone">
                      <el-input v-model="paymentInfoParam.phone"></el-input>
                    </el-form-item>                
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="form-group">
              <label class="labels">E-mail</label>
              <el-form-item prop="email">
                <el-input v-model="paymentInfoParam.email" type="text"  auto-complete="off"></el-input>
              </el-form-item>
            </div>
            <div class="paymentInfo-title"><span>Employment Info</span><div class="line"></div></div>
            <div class="form-group form-group-cow">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels"><span>*</span>Hire date</label>
                    <el-form-item prop="hireDate">
                      <el-date-picker
                        v-model="paymentInfoParam.hireDate"
                        type="date"
                        placeholder="Select Date"
                        :picker-options="pickerOptionsBefore">
                      </el-date-picker>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels">Termination date</label>
                    <el-form-item prop="terminationDate">
                      <el-date-picker
                        v-model="paymentInfoParam.terminationDate"
                        type="date"
                        placeholder="Select Date"
                        :picker-options="pickerOptionsBefore">
                      </el-date-picker>
                    </el-form-item>          
                  </div>
                </el-col>
              </el-row>
            </div>  
            <div class="form-group">
              <label class="labels"><span>*</span>Status</label>
              <el-form-item prop="status">
                <el-input v-model="paymentInfoParam.status" type="text"  auto-complete="off"></el-input>
              </el-form-item>
            </div>   
            <div class="form-group">
              <label class="labels">Check stub message</label>
              <el-form-item prop="checkSubMessage">
                <el-input v-model="paymentInfoParam.checkSubMessage" type="textarea"  auto-complete="off" resize="none"></el-input>
              </el-form-item>
            </div>  
            <div class="paymentInfo-title"><span>Work Location</span><div class="line"></div></div>
            <div class="form-group">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels">Work State</label>
                    <div class="select-box">
                      <el-form-item prop="workState">
                        <el-select  v-model="paymentInfoParam.workState" placeholder="Select a value">
                          <el-option
                            v-for="item in provinceList"
                            :key="item.id"
                            :label="item"
                            :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div>            
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content">
                    <label class="labels">Work Local</label>
                    <el-form-item prop="workLocal">
                      <el-input v-model="paymentInfoParam.workLocal"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </div>     
            <div class="form-group text-align-center">
              <el-button class="btn" :loading="btnLoading" @click="saveBasicBankInfo">Next</el-button>
            </div>                           
          </el-form>
       </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "components/app-header/app-header";
import AppSilder from "components/app-silder/app-silder";
import { ERR_OK } from "api/config";
import { getBankInfo, saveBankInfo, saveBasicBankInfo } from "api/payment";
export default {
  data() {
    var confirmRoutingNumberFn = (rule, value, callback) => {
      if (this.bankForm.routingNumber !== "") {
        if (value !== this.bankForm.routingNumber) {
          callback(new Error("Input routing number Inconsistent"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var confirmAccountNumberFn = (rule, value, callback) => {
      if (this.bankForm.accountNumber !== "") {
        if (value !== this.bankForm.accountNumber) {
          callback(new Error("Input account number Inconsistent"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      step: parseInt(this.$route.query.step),
      btnLoading: false,
      pickerOptionsBefore: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      provinceList: [
        "Alabama",
        "Alaska",
        "American Samoa",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "District of Columbia",
        "Federated States of Micronesia",
        "Florida",
        "Georgia",
        "Guam",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Marshall Islands",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Northern Mariana Islands",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Palau",
        "Pennsylvania",
        "Puerto Rico",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virgin Island",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming"
      ],
      paymentInfoParam: {
        firstName: "",
        middleInitial: "",
        lastName: "",
        socialSecurityNo: "",
        companyName: "",
        tin: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        zipCode: "",
        phone: "",
        email: "",
        hireDate: "",
        status: "",
        terminationDate: "",
        checkSubMessage: "",
        workState: "",
        workLocal: ""
      },
      bankForm: {
        accountType: "",
        nickname: "",
        bankName: "",
        routingNumber: "",
        confirmRoutingNumber: "",
        accountNumber: "",
        confirmAccountNumber: "",
        depositDistribution: ""
      },
      formRules: {
        firstName: [
          {
            required: true,
            message: "Please enter firstName",
            trigger: "blur"
          }
        ],
        lastName: [
          {
            required: true,
            message: "Please enter lastName",
            trigger: "blur"
          }
        ],
        socialSecurityNo: [
          {
            required: true,
            message: "Please enter socialSecurityNo",
            trigger: "blur"
          }
        ],
        state: [
          {
            required: true,
            message: "Please choose state",
            trigger: "change"
          }
        ],
        phone: [
          {
            required: true,
            message: "Please enter phone",
            trigger: "blur"
          }
        ],
        email: [
          {
            type: "email",
            message: "Please enter a valid email address",
            trigger: "blur"
          }
        ],
        hireDate: [
          {
            required: true,
            message: "Please choose hireDate",
            trigger: "change"
          }
        ],
        status: [
          {
            required: true,
            message: "Please enter status",
            trigger: "blur"
          }
        ]
      },
      bankFormRules: {
        confirmRoutingNumber: [
          { validator: confirmRoutingNumberFn, trigger: "blur" }
        ],
        confirmAccountNumber: [
          { validator: confirmAccountNumberFn, trigger: "blur" }
        ]
      }
    };
  },
  components: {
    AppHeader,
    AppSilder
  },
  created() {
    this._getBankInfo();
  },
  methods: {
    _getBankInfo() {
      getBankInfo()
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              if (response.data.data) {
                this.paymentInfoParam = response.data.data;
                this.bankForm = response.data.data;
                this.bankForm.confirmRoutingNumber = response.data.data.routingNumber;
                this.bankForm.confirmAccountNumber = response.data.data.accountNumber;
              }
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    saveBankInfo() {
      let vm = this;
      this.$refs.bankForm.validate(valid => {
        if (valid) {
          saveBankInfo(this.bankForm)
            .then(response => {
              if (response.status !== 200) {
                this.$message.error(response.data.message);
              } else {
                if (response.data.code === ERR_OK) {
                  this.$message.success(`save successful`);
                  setTimeout(function() {
                    vm.$router.push({
                      path: "/payment"
                    });
                  }, 2000);
                } else {
                  this.$message.error(response.data.message);
                }
              }
              this.btnLoading = false;
            })
            .catch(e => {
              this.$message.error(e.message);
              this.btnLoading = false;
            });
        }
      });
    },
    saveBasicBankInfo() {
      this.$refs.paymentInfoParam.validate(valid => {
        if (valid) {
          this.btnLoading = true;
          saveBasicBankInfo(this.paymentInfoParam)
            .then(response => {
              if (response.status !== 200) {
                this.$message.error(response.data.message);
              } else {
                if (response.data.code === ERR_OK) {
                  this.$message.success(`save successful`);
                  this.step = 2;
                } else {
                  this.$message.error(response.data.message);
                }
              }
              this.btnLoading = false;
            })
            .catch(e => {
              this.$message.error(e.message);
              this.btnLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~styles/variables.scss";
@import "~styles/mixin.scss";
.app-main-inner {
  .app-main-middle {
    padding: 20px 50px;
    .paymentInfo-box {
      width: 800px;
      margin: 0 auto;
      h1 {
        text-align: center;
        color: #ffa438;
        font-size: 30px;
        margin: 20px 0px 20px;
      }
      h2 {
        text-align: center;
        color: #a8a8a8;
        font-size: 15px;
        margin: 20px 0px 20px;
      }
      .paymentInfo-title {
        width: 100%;
        position: relative;
        text-align: center;
        height: 40px;
        line-height: 40px;
        margin: 20px 0px;
        .line {
          position: absolute;
          width: 100%;
          height: 1px;
          top: 20px;
          background-color: #000;
        }
        span {
          background-color: #fff;
          color: #000;
          padding: 0 10px;
          position: relative;
          z-index: 1;
        }
      }
    }
  }
}
.btn {
  width: 300px;
  margin: 0 auto;
}
.labels {
  float: left;
  height: 36px;
  line-height: 36px;
  color: #333;
  font-size: 15px;
  span {
    color: red;
    position: relative;
    top: 3px;
    margin-right: 5px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/payment/paymentInfo.vue